"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCodeblockPlugin = initCodeblockPlugin;

var _dom = require("../utils/dom");

var _utils = require("./utils");

// Handle block formatting of the selection within a codeblock/pre tag.
// This splits the block into {before} & {after} code blocks and inserts the
// originally selected content as a new block of the selected {format}.
function initCodeblockPlugin(editor) {
  editor.addCommand('hscodeblock', function (cmd, _ref) {
    var format = _ref.format,
        applyFormatDefault = _ref.applyFormatDefault;
    var selectedNode = editor.selection.getNode();
    var rng = editor.selection.getRng();
    var parentCodeblock = editor.dom.getParent(selectedNode, 'pre'); // Selection spans past & outside the codeblock, so treat the entire block as selected

    if (!parentCodeblock) {
      parentCodeblock = editor.dom.getParent(rng.startContainer, 'pre');
      rng.setStartBefore(parentCodeblock);
      editor.selection.setRng(rng);
      applyFormatDefault();
      return;
    } // Execute the original formatter.apply if the selection is the entire code block


    if (selectedNode === parentCodeblock && selectedNode.firstChild === rng.startContainer && selectedNode.lastChild === rng.endContainer || selectedNode !== parentCodeblock && editor.selection.isCollapsed() && (0, _utils.isNestedOnlyChild)(selectedNode, parentCodeblock)) {
      applyFormatDefault();
      return;
    }

    var bookmark;

    if (rng.collapsed) {
      var parentBlock = editor.dom.getParent(rng.startContainer, 'strong,em,a,span:not([data-mce-type="bookmark"])', parentCodeblock);

      if (parentBlock) {
        editor.selection.select(parentBlock);
      } else {
        // Treat entire codeblock as selection unless the cursor is on the
        // the last empty line
        bookmark = editor.selection.getBookmark();

        var _editor$dom$get = editor.dom.get(bookmark.id + "_start"),
            previousSibling = _editor$dom$get.previousSibling,
            nextSibling = _editor$dom$get.nextSibling;

        if (previousSibling && previousSibling.nodeName === 'BR' && nextSibling && nextSibling.nodeName === 'BR') {
          // Occasionally there is an empty text node after the last <br>
          if ((0, _utils.isNestedLastChild)(nextSibling, parentCodeblock) || nextSibling.nextSibling && nextSibling.nextSibling.nodeName === '#text' && nextSibling.nextSibling.nodeValue === '' && (0, _utils.isNestedLastChild)(nextSibling.nextSibling, parentCodeblock)) {
            editor.dom.remove(previousSibling);
          }
        } else {
          editor.selection.moveToBookmark(bookmark);
          editor.selection.select(parentCodeblock);
          applyFormatDefault();
          return;
        }
      }
    }

    bookmark = bookmark || editor.selection.getBookmark();
    var bookmarkNodes = {
      getStart: function getStart() {
        return editor.dom.get(bookmark.id + "_start");
      },
      getEnd: function getEnd() {
        return editor.dom.get(bookmark.id + "_end") || editor.dom.get(bookmark.id + "_start");
      }
    };
    var bookmarkStart = bookmarkNodes.getStart();
    var bookmarkEnd = bookmarkNodes.getEnd();
    var clonedCodeblock = parentCodeblock.cloneNode(true);
    var content = (0, _utils.getContentOfSelection)(editor, rng, bookmarkStart, bookmarkEnd);
    var afterContent = (0, _utils.getContentOfSelection)(editor, rng, bookmarkEnd, parentCodeblock.lastChild); // Clear content of and after the selection

    (0, _utils.clearRngContent)(editor, rng, bookmarkStart, parentCodeblock.lastChild); // Create new format block with the old content

    var newBlock = editor.dom.create(format, {}, content || _dom.BOGUS_BR);
    editor.dom.insertAfter(newBlock, parentCodeblock); // Remove previous codeblock if empty

    if (!parentCodeblock.childNodes.length || parentCodeblock.childNodes.length === 1 && parentCodeblock.childNodes[0].nodeName === '#text' && parentCodeblock.childNodes[0].nodeValue === '') {
      parentCodeblock.parentNode.removeChild(parentCodeblock);
    } // Insert cloned codeblock with content before and of the selection cleared


    if (afterContent !== '' && afterContent !== '&nbsp;') {
      editor.dom.insertAfter(clonedCodeblock, newBlock);
      bookmarkEnd = bookmarkNodes.getEnd();

      if (bookmarkEnd.nextSibling && bookmarkEnd.nextSibling.nodeName === '#text' && bookmarkEnd.nextSibling.nodeValue === '') {
        bookmarkEnd = bookmarkEnd.nextSibling;
      }

      if (bookmarkEnd.nextSibling && bookmarkEnd.nextSibling.nodeName === 'BR') {
        bookmarkEnd = bookmarkEnd.nextSibling;
      }

      (0, _utils.clearRngContent)(editor, rng, clonedCodeblock.firstChild, bookmarkEnd);
    }

    editor.selection.setCursorLocation(newBlock, newBlock.childNodes.length);
  });
}